import React from 'react';

const VerifiedBadge = ({ size = 20, className = "" }) => {
  return (
    <span 
      className={className}
      title="Verified Pro"
      style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginLeft: '6px', 
                verticalAlign: '-0.2em', 
                position: 'relative',    
                flexShrink: 0            
      }}
    >
      <svg 
        width={size} 
        height={size} 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          {/* RENAMED ID TO PREVENT CONFLICTS WITH ORANGE BADGE */}
          <linearGradient id="shieldGradientGreen" x1="2.00003" y1="5.99999" x2="22" y2="20" gradientUnits="userSpaceOnUse">
            <stop stopColor="#34d399" /> {/* Emerald 400 */}
            <stop offset="1" stopColor="#059669" /> {/* Emerald 600 */}
          </linearGradient>
        </defs>
        
        {/* The Shield Background */}
        <path 
          d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" 
          fill="url(#shieldGradientGreen)" 
          stroke="#047857" /* Darker Emerald for border definition */
          strokeWidth="1"
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
        
        {/* The White Checkmark */}
        <path 
          d="M9 12L11 14L15 10" 
          stroke="white" 
          strokeWidth="2.5" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export default VerifiedBadge;